<template>
  <div class="chart-line">
    <div class="line-header">
      <div class="line-title">
        <BaseIcon
          v-if="hasWritePermission && item.widgetName"
          class="cus-home-drag-n-drop-pointer"
          name="dragNDrop"
          width="0.813rem"
          height="1.25rem"
        />
        {{ item.widgetName }}
        <div v-if="hasWritePermission" @click="deleteWidget" class="icon-title">
          <BaseIcon
            name="deleteFilled"
            width=".9125rem"
            height=".9125rem"
            v-if="item.header"
          />
        </div>
      </div>
      <div class="capability">
        <span class="icon-capability">
          <BaseIcon
            :name="item.capability.toLowerCase()"
            width=".9125rem"
            height=".9125rem"
          />
        </span>
        <span class="headings">
          {{ item.capability }}
        </span>
      </div>
      <div class="line-icon">
        <div class="appName" @click="redirectAppInput(item)">
          {{ item.serviceName }}
        </div>

        <div>
          <span class="icon-class" @click="handleZoomOut">
            <BaseIcon name="zoomOut" width="2.438em" height="2.438em" />
          </span>
          <span class="icon-class" @click="handleZoomIn">
            <BaseIcon name="zoomIn" width="2.438em" height="2.438em" />
          </span>
          <span class="icon-class" @click="handleReset">
            <BaseIcon name="reset" width="1.438em" height="2.438em" />
          </span>
        </div>
      </div>
    </div>
    <div class="chart-body">
      <apexchart
        height="100%"
        type="area"
        :options="options"
        :series="option"
        ref="chart"
      ></apexchart>
    </div>
  </div>
</template>
<script>
import BaseIcon from '@/rex-components/BaseIcon.vue';
import {
  ToolTip,
  Grid,
  Legend,
  Markers,
  ChartToolBar,
  Animations,
  XAxisConfig,
  YAxisConfig,
} from '@/components/charts/charts.global.config';
import { mapMutations, mapActions, mapGetters } from 'vuex';
import { replaceSpaceInId } from '../../utils/helper-function';
import { Capability } from '@/utils/enums/metricType';
import { CAPABILITY_MOBILE } from '@/utils/constants';
import { usePermissions } from '@/hooks/usePermissions';
import { HOME_RESOURCE_GROUP } from '@/router/constant';
export default {
  components: { BaseIcon },
  name: 'ApexChartAreaCustom',
  props: {
    data: {},
    type: {},
    intervalTime: {},
    item: {},
    index: {},
  },
  data: function () {
    return {
      minX: 1,
      maxX: this.intervalTime.length,
      options: {
        chart: {
          id: `vuechart-area-${this.index}`,
          width: '100%',
          height: '100%',
          group:
            typeof this.item.isSynchronized === 'undefined' ||
            this.item.isSynchronized
              ? 'group'
              : '',
          background: 'inherit',
          events: {
            zoomed: (chartContext, { xaxis, yaxis }) => {
              this.updateMinMax(xaxis);
            },
            // beforeMount: (chartContext, config) => {
            //   console.log('config', config);
            //   this.setConfig(config);
            // }
          },
          toolbar: ChartToolBar,
        },
        grid: Grid,
        fill: {
          type: 'gradient',
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.9,
            opacityTo: 0.2,
            stops: [0, 100],
          },
        },
        stroke: {
          curve: 'smooth',
          width: 1,
        },
        dataLabels: {
          enabled: false,
        },
        markers: {
          size: 0,
          style: 'hollow',
        },
        tooltip: {
          enabled: true,
          enabledOnSeries: undefined,
          shared: true,
          followCursor: false,
          intersect: false,
          inverseOrder: false,
          custom: undefined,
          fillSeriesColor: false,
          theme: 'dark',
          style: {
            fontSize: '12px',
            fontFamily: undefined,
          },
          onDatasetHover: {
            highlightDataSeries: false,
          },
          x: {
            show: true,
            format: 'dd MMM',
            formatter: undefined,
          },
          y: {
            formatter: undefined,
            title: {
              formatter: (seriesName) => seriesName,
            },
          },
          z: {
            formatter: undefined,
            title: 'Size: ',
          },
          marker: {
            show: true,
          },
          items: {
            display: 'flex',
          },
          fixed: {
            enabled: false,
            position: 'topRight',
            offsetX: 0,
            offsetY: 0,
          },
        },
        colors: this.item.chartColor,
        xaxis: {
          tickAmount: this.intervalTime.length > 14 ? 5 : 3,
          ...XAxisConfig,
          title: {
            text: this.item.axisLabels.x,
            ...XAxisConfig.title,
          },
          labels: {
            ...XAxisConfig.labels,
            rotateAlways: false,
            hideOverlappingLabels: true,
            showDuplicates: false,
            trim: false,
            maxHeight: 120,
            style: {
              colors: [],
              fontSize: '0.875em',
              ...XAxisConfig.labels.style,
            },
          },
        },
        yaxis: {
          ...YAxisConfig,
          title: {
            text: this.item.axisLabels.y,
            align: 'left',
            ...YAxisConfig.title,
            offsetX: 0,
            offsetY: 0,
          },
        },
        legend: !this.item.showLegendForSingle
          ? Legend
          : { ...Legend, showForSingleSeries: true },
      },
    };
  },

  methods: {
    ...mapMutations('homeState', ['setdeleteWidgetId']),
    ...mapActions('apmState/apmCommonState', ['selectService']),
    ...mapActions('mobileState/mobileCommonState', ['selectMobileService']),
    deleteWidget() {
      this.setdeleteWidgetId(this.item.id);
    },
    redirectAppInput(option) {
      const query = {
        id: option.serviceKey,
      };

      if (option.capability === Capability.APM) {
        this.$router.push({
          name: 'dashboard',
          query,
        });
      } else if (option.capability === CAPABILITY_MOBILE) {
        if (option.isCrashes) {
          this.$router.push({
            name: 'crashesGraphs',
            query,
          });
        } else if (option.isPerformance) {
          this.$router.push({
            name: 'performanceGraphs',
            query,
          });
        } else {
          this.$router.push({
            name: 'mobile',
            query,
          });
        }
      } else {
        this.$router.push({
          name: 'browser',
          query,
        });
      }
    },
    resize() {
      const chart = this.$refs.chart;
      chart.myChart.resize();
    },
    setConfig(config) {
      // console.log('configss', config.globals.maxX);
      // this.minX = config.globals.maxX;
      // this.maxX = config.globals.maxX;
    },
    handleZoomIn() {
      // Find minMax for x

      try {
        if (this.$refs.chart.chart.w.globals.minX)
          this.minX = this.$refs.chart.chart.w.globals.minX;
        if (this.$refs.chart.chart.w.globals.maxX)
          this.maxX = this.$refs.chart.chart.w.globals.maxX;
      } catch (error) {
        // Todo: Handle error
      }

      if (
        typeof this.minX === 'undefined' &&
        typeof this.maxX === 'undefined'
      ) {
        this.handleReset();
      }
      if (this.maxX - this.minX > 2) {
        const centerX = (this.minX + this.maxX) / 2;
        let newMinX = (this.minX + centerX) / 2;
        let newMaxX = (this.maxX + centerX) / 2;
        const newMinXMaxX = this._getNewMinXMaxX(newMinX, newMaxX);
        this.minX = newMinXMaxX.minX;
        this.maxX = newMinXMaxX.maxX;
        this.$refs.chart.zoomX(this.minX, this.maxX);
      }
    },
    handleReset() {
      this.$refs.chart.zoomX();
      this.minX = 1;
      this.maxX = this.intervalTime.length;
    },
    _getNewMinXMaxX(newMinX, newMaxX) {
      return {
        minX: Math.floor(newMinX),
        maxX: Math.floor(newMaxX),
      };
    },
    updateMinMax(xaxis) {
      this.minX = xaxis.min;
      this.maxX = xaxis.max;
    },
    handleZoomOut() {
      // this.$refs.chart.zoomX();
      //Find minMax for x

      try {
        if (this.$refs.chart.chart.w.globals.minX)
          this.minX = this.$refs.chart.chart.w.globals.minX;
        if (this.$refs.chart.chart.w.globals.maxX)
          this.maxX = this.$refs.chart.chart.w.globals.maxX;
      } catch (error) {
        // Todo: Handle error
      }

      if (
        typeof this.minX === 'undefined' &&
        typeof this.maxX === 'undefined'
      ) {
        this.handleReset();
      }
      if (this.minX > 0 && this.maxX - this.minX >= 1) {
        const centerX = (this.minX + this.maxX) / 2;
        let newMinX = this.minX - (centerX - this.minX);
        let newMaxX = this.maxX - (centerX - this.maxX);
        const newMinXMaxX = this._getNewMinXMaxX(newMinX, newMaxX);
        this.minX = newMinXMaxX.minX;
        this.maxX = newMinXMaxX.maxX;
        this.$refs.chart.zoomX(this.minX, this.maxX);
      }
    },
    replaceSpaceInId,
  },
  computed: {
    ...mapGetters('globalState/settings', ['getDurationTime']),
    option() {
      const keys = Object.keys(this.data || {}).filter(
        (i) => Array.isArray(this.data[i]) && this.data[i].length,
      );
      // eslint-disable-next-line no-unused-vars
      const temp = keys.map((i, index) => {
        const serie = {
          name: i,
          data: this.data[i].map((item, itemIndex) => ({
            x:
              typeof this.intervalTime[itemIndex] === 'undefined'
                ? ''
                : this.intervalTime[itemIndex],

            y: item,
          })),
        };
        return serie;
      });
      return temp;
    },
    hasWritePermission() {
      const { hasCapabilityWritePermission } = usePermissions();

      return hasCapabilityWritePermission(HOME_RESOURCE_GROUP);
    },
  },
  watch: {
    minX(oldVal, newVal) {
      // console.log('oldval', oldVal);
      // console.log('newval', newVal);
    },
  },
};
</script>
<style lang="scss" scoped>
.chart-body {
  margin-right: 2px;
  margin-left: 0.125em;
  height: 20.625em;
  border-radius: 1.0625em;
}

.chart-line {
  width: 100%;
  border-radius: 1.0625em;
  background-color: $bg-secondary;
}
.line-content-error {
  color: $poor;
  margin-left: 1em;
  .line-error-percentage {
    margin-right: 1.125rem;
  }
  .line-errors {
    margin-right: 1em;
  }
}
.line-content {
  margin-left: 1em;
  .line-content-calls {
    margin-right: 1.3em;
  }
}
.line-header {
  height: 2.375em;
  border-bottom: 0.0063em solid $border-primary;
  @include flex-center-justify(space-between);
  color: $font-primary;
  .line-title {
    margin-left: 0.8625em;
    font-family: $semi-bold;
    fill: $color-brand-accent;
    display: flex;
  }
  .icon-title {
    cursor: pointer;
    margin-left: 0.4em;
    margin-top: -0.1em;
  }
  .line-icon {
    margin-right: 0.8125em;

    @include flex-center-justify(space-between);
  }
  .icon-class:hover {
    cursor: pointer;
    svg {
      fill: $font-secondary !important;
    }
  }
  .icon-class {
    fill: $color-brand-accent !important;
  }
  .icon-class:last-child {
    margin-left: 0.3125em;
  }
  .icon-class:first-child {
    margin-right: -0.3125em;
  }
}

.appName {
  height: 1.875em;
  color: $color-brand-accent;
  cursor: pointer;
  font-family: $semi-bold;
  font-size: 0.75em;
  text-align: center;
  align-items: center;
  padding-top: 2px;
  &:hover {
    text-decoration: underline;
  }
}
.apdex {
  padding-left: 20px;
}
.apdex.poor {
  color: $poor;
}
.apdex.fair {
  color: $fair;
}
.apdex.good {
  color: $good;
}
.capability {
  height: 1.875em;
  color: $font-primary;
  font-family: $semi-bold;
  font-size: 0.75rem;
  text-align: center;
  align-items: center;
  margin-left: auto;
  margin-right: 1rem;
  padding-top: 2px;
  .icon-capability {
    fill: $font-primary;
    margin-right: 0.3125em;
  }
}
.cus-home-drag-n-drop-pointer {
  fill: $color-brand-accent;
  margin-right: 0.5rem;
  cursor: pointer;
}
</style>
